import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const paydConfig: TSPConfig = {
  key: 'payd',
  name: 'Payd',
  category: TSPCategory.API_KEY,
  helpText: 'Please request an API key from your Payd representative.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default paydConfig;
